import React, { Component } from 'react'
import { OrganizationLabels, LabelsMy } from 'containers/pages'
import { meta } from 'helpers/decorators'
import { Section, SubTab, SubTabs } from '../../../components/layout'

@meta({
  title: 'Labels',
  intlKey: 'pageTitle.labels'
})
class MyRegionOfficeLabels extends Component {
  render() {
    return (<Section>
      <SubTabs compact>
        <SubTab title="Office Labels" intlKey="moduleTitle.office_labels">
          <LabelsMy />
        </SubTab>
        <SubTab title="Child Organization Labels" intlKey="moduleTitle.child_organization_labels">
          <OrganizationLabels />
        </SubTab>
      </SubTabs>
    </Section>)
  }
}

export default MyRegionOfficeLabels
